
import { setToastData } from "../../Store/reducers/Toast";
import { useDispatch } from "react-redux";
const PasswordStrengthMeter = ({
  password
}) => {
  const pwdValidate = password;
  const dispatch = useDispatch();
  const initPwdChecker = () => {
    let pwdCheck = 0;
    
    let validateRegex = ["[A-Z]", "[a-z]", "[0-9]", "\\W"];
    validateRegex.forEach((regex, i) => {
      if (new RegExp(regex).test(pwdValidate)) {
        pwdCheck += 1;
      }
    });
    switch (pwdCheck) {
      case 0:
        return {
          strength: 0,
          val: "",
        };
      case 1:
        return {
          strength: 1,
          val: "Weak",
        };
      case 2:
        return {
          strength: 2,
          val: "Fair",
        };
      case 3:
        return {
          strength: 3,
          val: "Good",
        };
      case 4:
        return {
          strength: 4,
          val: "Strong",
        };
      default:
        return null;
    }
  };

  const popupHandler = () => {
    dispatch(
        setToastData({
          message: '<div className="password-help-text"><h3>Password Help</h3><br /><ul><li>Password must be minimum 8 characters.</li><li>Password must contain atleast one UPPERCASE letter.</li><li>Password must contain atleast one lowercase letter.</li><li>Password must contain atleast one special symbol: @$! % * ? &. </li></ul></div>',
          isHtml: true,
          type: "",
          showCloseBtn: true,
        })
      );
  }
  return (
    <>
      <div className="wrapper">
        <progress
          className={`width-100 pwd-checker-bar strength-${
            initPwdChecker().val
          }`}
          value={initPwdChecker().strength}
          max="4"
        />
        <p className="pwd-label">
          {password && (
            <div>
              <p className={`label strength-${initPwdChecker().val}`}>
                <small>
                  <i
                    className="icon-info"
                    title="Help"
                    onClick={popupHandler}
                    
                  ></i>
                  &nbsp;Password Strength:&nbsp;
                  <strong>{initPwdChecker().val} </strong>
                </small>
              </p>
            </div>
          )}
        </p>
      </div>
    </>
  );
};
export default PasswordStrengthMeter;
